import type {
  LscLiveSubscription,
  LscLiveSubscriptionSyncItem,
  LscLiveSubscriptionSyncSummary,
} from '../types';

export function latestLiveDetectionSyncAt(subscriptions: LscLiveSubscription[]): string | null {
  let latest: string | null = null;
  for (const subscription of subscriptions) {
    if (!subscription.last_sync_at) continue;
    if (!latest || subscription.last_sync_at > latest) {
      latest = subscription.last_sync_at;
    }
  }
  return latest;
}

export function countPlannedSubscriptionItems(items: LscLiveSubscriptionSyncItem[]): number {
  return items.filter((item) => item.action === 'planned').length;
}

export function failedMemberIdsFromSyncItems(items: LscLiveSubscriptionSyncItem[]): string[] {
  const ids = new Set<string>();
  for (const item of items) {
    if (item.action === 'failed' && item.member_id) {
      ids.add(item.member_id);
    }
  }
  return Array.from(ids);
}

export function countSuccessfulEligibleMembers(
  summary: LscLiveSubscriptionSyncSummary,
  items: LscLiveSubscriptionSyncItem[]
): number {
  const failedCount = failedMemberIdsFromSyncItems(items).length;
  return Math.max(0, summary.eligible_members - summary.members_skipped - failedCount);
}

export function formatSyncResultMessage(
  summary: LscLiveSubscriptionSyncSummary,
  items: LscLiveSubscriptionSyncItem[]
): string {
  const succeeded = countSuccessfulEligibleMembers(summary, items);
  const eligible = summary.eligible_members;
  if (summary.subscriptions_failed > 0) {
    return `Live detection synced for ${succeeded} of ${eligible} eligible members.`;
  }
  return `Live detection synced for ${succeeded} of ${eligible} eligible members.`;
}
